/** In-app branding images only (not favicon / PWA install icons). */
const publicUrl = process.env.PUBLIC_URL || "";

export const LOGO_NAV_URL = `${publicUrl}/qnaread-logo.png`;
export const LOGO_HERO_URL = `${publicUrl}/qnalogo.png`;
